<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.4385 6.65234C16.5105 7.36685 18 9.33367 18 11.6484V16.5459C17.9998 17.349 17.3481 18.0009 16.5449 18.001H13.25C10.8087 18.0009 8.71974 16.496 7.85645 14.3643H8.87891C12.092 14.3642 14.6971 11.759 14.6973 8.5459V8.3418C14.6973 7.75317 14.6065 7.18547 14.4385 6.65234ZM7.81836 2C11.0316 2.0001 13.6367 4.60513 13.6367 7.81836C13.6366 11.0315 11.0315 13.6366 7.81836 13.6367H3.4541C2.65098 13.6365 2 12.9848 2 12.1816V7.81836C2 4.60507 4.60507 2 7.81836 2ZM7.16406 11.4551H8.56055V10.1631H7.16406V11.4551ZM8.09766 4.90039C7.62659 4.90041 7.22807 4.99364 6.90234 5.17969C6.57653 5.36005 6.32888 5.60472 6.16016 5.91309C5.99144 6.22144 5.90723 6.56222 5.90723 6.93457H7.06836C7.06836 6.74257 7.10897 6.57319 7.19043 6.42773C7.27182 6.28253 7.38506 6.16629 7.53027 6.0791C7.68146 5.99188 7.86198 5.94829 8.07129 5.94824C8.26329 5.94824 8.43267 5.98589 8.57812 6.06152C8.72346 6.13716 8.83359 6.24818 8.90918 6.39355C8.98475 6.53315 9.02246 6.69871 9.02246 6.89062C9.02246 7.15826 8.93826 7.38511 8.76953 7.57129C8.60664 7.75156 8.3509 7.84177 8.00195 7.8418H7.25977V9.39551H8.46387L8.47461 8.72461C8.73875 8.68345 8.97369 8.61297 9.17969 8.51367C9.51132 8.35076 9.76194 8.12986 9.93066 7.85059C10.0993 7.57135 10.1836 7.25426 10.1836 6.89941V6.79492C10.1836 6.43431 10.0993 6.1112 9.93066 5.82617C9.76195 5.5411 9.5202 5.3172 9.20605 5.1543C8.89769 4.98557 8.5282 4.90039 8.09766 4.90039Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
